import moment from "moment";

export default function useDateConvert(): Record<string, unknown> {

  const convertDatetime = (date: Date, format = "YYYY-MM-DD HH:mm:ss"): string => {
    return moment(date).format(format)
  }

  return {
    convertDatetime
  }
}
